module.exports = __webpack_public_path__ + "static/cmmiSS-b554ffe18b92ae9f63cc4816df9d70a1.png";